<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Painel de Manutenção - Locker {{$route.params.id}}</h4>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <!-- <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData">
            <el-table-column label="Opção" property="options" min-width="340"></el-table-column>
            <el-table-column label="Ações" width="140">
              <div class="td-actions" slot-scope="props">
                <a
                  class="btn btn-danger btn-link btn-xs"
                  @click="openDoor(props.$index, props.row)"
                >
                  <i class="fa fa-unlock"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div> -->
      </card>
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Configurações</h4>
        </div>
        <div>
          <fg-input name="sound" label="Som">
          <div>
            <l-switch v-model="model.sound"></l-switch>
          </div>
          </fg-input>

          <fg-input v-if="model.sound" name="volume" label="Volume">
            <el-slider :class="color(model.volume)" v-model="model.volume"/>
          </fg-input>

          <fg-input name="repositor_pwd" type="number" label="Senha de Reposição" v-model="model.repositor_pwd"></fg-input>
         
          <fg-input name="video" label="Vídeo">
            <div>
              <l-switch v-model="model.video"></l-switch>
            </div>
          </fg-input>
          <fg-input name="out_service" label="Máquina fora de serviço" v-if="showOut">
            <div>
              <l-switch v-model="model.out_of_service" @input="outService()"></l-switch>
            </div>
          </fg-input>

        </div>

      </card>
      <card>
        <div>
          <button type="submit" @click.prevent="save" class="btn btn-fill btn-info btn-wd">Salvar</button>
        </div>
    </card>
    </div>
  </div>
</template>
<script>
import { Table,
  TableColumn,
  Select,
  Option,
  Slider, } from "element-ui";
import swal from "sweetalert2";
import { Switch as LSwitch } from "src/components/index";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Slider.name]: Slider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    LSwitch
  },
  data() {
    return {
      model: {
        sound: false,
        volume: 30,
        repositor_pwd: "",
        video: false,
        out_of_service: false,
      },
      showOut: false,
      }
  },
  computed: {
    tableData() {
      var dados = [
          {options: 'Porta'}
      ] 
      return dados;
    }
  },
  mounted() {
    this.$store.dispatch("lockers/list").then(() => {
      this.model = this.$store.state.lockers.lockers.find(
        e => e.id == this.$route.params.id
      );
    })
    this.ifFlag()
  },
  methods: {
    openDoor () {
      swal.fire({
        title: "Atenção!",
        text: `Você está prestes a abrir a porta da máquina. Após a confirmação, a maquina irá soltar um "beep" por 2 segundos
        e outro novamente após 25 segundos. A porta só estará destrancada durante os "beep".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, abra!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          var machineId = this.$route.params.id
          this.$store.dispatch('machines/open', {url: machineId + "/open_door/", item: {
                "topic": "door",
                "action": "open"
            }} )
          let timerInterval
          swal.fire({
            title: 'Abrindo porta!',
            html: 'Próximo "beep" será em <b></b> segundos.',
            timer: 25000,
            timerProgressBar: true,
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              swal.showLoading()
              timerInterval = setInterval(() => {
                swal.getContent().querySelector('b')
                  .textContent = (swal.getTimerLeft()/1000).toFixed(0)
              }, 1000)
            },
            willClose: () => {
              clearInterval(timerInterval)
            }
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Comando de abrir porta não enviado.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    color(value) {
      if (value <= 75) {
        return "slider-success";
      } else {
        return "slider-danger";
      }
    },
    ifFlag() {
      // console.log('asd', this.$store.state.general.flag)
      this.$store.state.general.flag.filter(el =>{
        if( el.vm == this.$route.params.id) {
          if (el.feature == 'V02') {
            if (el.active) {
              this.showOut = true
            }
          } 
        }
      })
    },
    save () {
      this.model.id = this.$route.params.id
      this.$store.dispatch("lockers/updateConfig", { item: this.model }).then(()=>{
        this.notifySuccess();
        this.$router.push(`/app/machines/lockers`);
      })
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifySuccessOUT() {
      this.$notify({
        message: "Sucesso</br>Locker fora de serviço!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifySuccessIN() {
      this.$notify({
        message: "Sucesso</br>Locker de volta ao serviço!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    outService () {
      if (this.model.out_of_service) {
        swal.fire({
          title: "Atenção!",
          text: `O locker ficará fora serviço.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, desativar locker!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('lockers/outService', {id: this.$route.params.id, item: {
                  "out_of_service": true
              }} ).then(data =>{
                if (data.status == '200') {
                  this.notifySuccessOUT()
                } else {
                  this.notifyError()
                }
                console.log('data', data)
              }) 
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Comando de desativar locker não foi enviado.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.out_of_service = false
          }
        });
      } else {
        swal.fire({
          title: "Atenção!",
          text: `O locker voltará ao serviço.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, ativar locker!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('lockers/outService', {id: this.$route.params.id, item: {
                  "out_of_service": false
              }} ).then(data =>{
                if (data.status == '200') {
                  this.notifySuccessIN()
                } else {
                  this.notifyError()
                }
              }) 
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Comando de ativar locker não foi enviado.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.out_of_service = true
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
